import React from 'react';
import IconCentroMedicoBazterica from './CentroMedicoBazterica';
import IconCentroMedicoSantaRita from './CentroMedicoSantaRita';
import IconClinicaBazterrica from './ClinicaBazterrica';
import IconClinicaDelSol from './ClinicaDelSol';
import IconClinicaSantaIsabel from './ClinicaSantaIsabel';


export const iconMap = {
  33: IconCentroMedicoBazterica,
  32: IconCentroMedicoSantaRita,
  387122: IconClinicaBazterrica,
  96: IconClinicaDelSol,
  387124: IconClinicaSantaIsabel,
  default: null 
};